<div class="client-sme-status-section">
    <div class="client-user-search table-filter">
        <input class="black-input opposite-colors table-search-input search-box-custom" required
            placeholder="Type to filter" type="text" no-special-chars="#!$@%^<>+=" aria-autocomplete="none"
            aria-expanded="false" role="search" (keyup)="filterClientUsers($event.target.value)" />
        <!-- <button type="reset" class="cross-icon" (click)="filterClientUsers($event.target.value)"></button> -->
    </div>
    <div class="sme-count-section">
        <div class="sme-total-label">Total SMEs</div>
        <div class="sme-total-count">{{clientSmeUsers.length}} </div>
    </div>
    <div class="sme-status-section">
        <div>
            <span>In Progress</span>
            <span class="user-inprogress-count">{{inProgressUsersCount}}</span>
        </div>
        <div class="sme-user-success-section">
            <span>Successful</span>
            <span class="user-success-count">{{successfullUsersCount}}</span>
        </div>
    </div>
    <div *ngIf="failedUsersCount > 0" class="sme-user-failed-section" [ngClass]="{'no-failed-user': failedUsersCount === 0}">
        Failed {{failedUsersCount}}
        <!-- <span>Failed</span>
        <span class="user-failed-count">{{failedUsersCount}}</span> -->
        <button class="link-button-top-border-red" data-toggle="tooltip"
            title="Click here to retry adding the client users that have failed." *ngIf="isAnyFailedUser"
            (click)="provisionFailedUsers()">
            Retry
        </button>
    </div>

    <div class="buttons-wrapper client-users-buttons-section btn-action">
        <div *ngIf="showAddUserOptions && canAddClientUsers && !isClientAdmin" class="link-button-top-border buttons-no-padding" (click)="addUser()">
            <a><i class="fas fa-plus"></i>Add SME</a>
        </div>
        <div *ngIf="showAddUserOptions && canAddClientUsers" class="link-button-top-border buttons-no-padding" (click)="addBulkUser()">
            <a *ngIf="showAddUserOptions && canAddClientUsers && !isClientAdmin" ><i class="fas fa-plus"></i> Import SMEs in Bulk</a>
            <i *ngIf="clientUserImportStatus === fileImportStatusEnum.Success"
                class="fas fa-check-circle fileImportSuccess"></i>
            <i *ngIf="clientUserImportStatus === fileImportStatusEnum.Error"
                class="fas fa-exclamation-circle completedWithError"></i>
        </div>
        <!-- Keep placeholders to prevent reordering when hidden -->
        <div *ngIf="showAddUserOptions && !canAddClientUsers" class="link-button-top-border buttons-no-padding"></div>
        <div *ngIf="showAddUserOptions && !canAddClientUsers" class="link-button-top-border buttons-no-padding"></div>

        <div *ngIf="showDeleteUser && canAddClientUsers"  class="delete-users-button">
            <button class="link-button-top-border-orange" *ngIf="showDeleteUser" (click)="sendDeletionRequest()">
                <i class="fas fa-trash"></i> Delete Users
            </button>
        </div>
    </div>

    <div class="table-filter">
        <ng-container *ngIf="tableDataFiltered">
            <strong></strong>&nbsp;<span *ngIf="tableDataFiltered.length !== 1"></span>
        </ng-container>
    </div>
</div>

<div class="primary-ngx-datatable-styling">
    <ngx-datatable [scrollbarH]="true" [scrollbarV]="true" [headerHeight]="60" [rowHeight]="55" [columnMode]='"force"'
        [rows]="clientSmeUsers" class="">
        <ngx-datatable-column [width]="50" *ngIf="!isClientAdmin && canAddClientUsers">
            <ng-template ngx-datatable-header-template let-row="row">
                <label class="kpmg-checkbox">
                    <input type="checkbox" [disabled]="row && row.isAssigned" [checked]="masterCheckboxControl"
                        (change)="selectMultiple()" /><span></span>
                </label>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <label class="kpmg-checkbox">
                    <input type="checkbox" [disabled]="!row.isProvisioned && row.userStatus === 'In Progress'"
                        [checked]="row.isSelected" [(ngModel)]="row.isSelected"
                        (change)="selectSingle(row)" /><span></span>
                </label>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Display Name">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"  let-row="row"  let-value="value">
                <input class="editable-input" (blur)="saveUserDetails(row)" [id]="'displayName' + rowIndex" title="Edit"
                    [(ngModel)]="row.displayName">
                <div>
                    <button class="link-button mr-2 editable-icon" *ngIf="!isClientAdmin" (click)="editUserDetails(rowIndex, 'displayName')">
                        <i class="fas fa-edit"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="First Name">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"  let-row="row"  let-value="value">
                <input class="editable-input" (keyup)="updateDisplayName($event, row)" (blur)="saveUserDetails(row)"
                    [id]="'firstName' + rowIndex" title="Edit" [(ngModel)]="row.firstName">
                <div>
                    <button class="link-button mr-2 editable-icon" *ngIf="!isClientAdmin" (click)="editUserDetails(rowIndex, 'firstName')">
                        <i class="fas fa-edit"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Last Name">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"  let-row="row"  let-value="value">
                <input class="editable-input" (keyup)="updateDisplayName($event, row)" (blur)="saveUserDetails(row)"
                    [id]="'lastName' + rowIndex" title="Edit" [(ngModel)]="row.lastName">
                <div>
                    <button class="link-button mr-2 editable-icon" *ngIf="!isClientAdmin" (click)="editUserDetails(rowIndex, 'lastName')">
                        <i class="fas fa-edit"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="250" name="Email">
            <ng-template class="cell-text-wrap"  ngx-datatable-cell-template let-rowIndex="rowIndex"  let-row="row"
                 let-value="value">
                {{row.emailId}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="100" prop="Status" name="Status">
            <ng-template ngx-datatable-cell-template let-j="rowIndex" let-value="value" let-row="row">
                <span
                    [ngClass]="row.isProvisioned ? 'user-status-success': row.errorMessage.length > 0 ?  'user-status-fail':''">
                    {{row.userStatus}}
                </span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="100" name="Manager">
            <ng-template let-column="column" ngx-datatable-header-template>
                <div class="client-admin-circle-info">
                    <span tooltip={{guidance_client_manager}} offset="0" zIndex="30000" [options]="toolTipOptions">
                        <i class="fas fa-info-circle"></i>
                    </span>
                    <span title="Client Manager" class="datatable-header-cell-label ">Manager</span>
                </div>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <label *ngIf="row.errorMessage  === ''"
                    class="datatable-checkbox child-checkbox kpmg-checkbox client-checkbox">
                    <input type="checkbox" [disabled]="isClientAdmin || (!row.isProvisioned && row.userStatus !== 'Successful')"
                        (change)="addClientManager($event , row )" [checked]="getClientManagerRole(row)" /><span></span>
                </label>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="100" name="Admin">
            <ng-template let-column="column" ngx-datatable-header-template>
                <div class="client-admin-circle-info">
                    <span tooltip={{guidance_client_admin}} offset="0" zIndex="30000" [options]="toolTipOptions">
                        <i class="fas fa-info-circle"></i>
                    </span>
                    <span title="Client Admin" class="datatable-header-cell-label">Admin</span>
                </div>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <label *ngIf="row.errorMessage  === ''" class="kpmg-checkbox ">
                    <input type="checkbox" [disabled]="isClientAdmin || (!row.isProvisioned && row.userStatus !== 'Successful')"
                        (change)="addClientAdmin($event , row)"
                        [checked]="getClientAdminRole(row)" /><span></span>
                </label>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="50" *ngIf="canAddClientUsers && !isClientAdmin">
            <ng-template ngx-datatable-cell-template let-row="row">
                <button *ngIf="row.userStatus !== 'In Progress'" class="link-button mr-2"
                    (click)="deleteClientUser(row)">
                    <i class="fas fa-trash rcn-coloring"></i>
                </button>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
